import { useOptionalSession } from 'src/contexts/SessionContext';

export interface IntercomProps {
  appId?: string;
  userId?: string;
  userHash?: string;
}

export const useIntercomProps = (): IntercomProps => {
  const { session, user } = useOptionalSession();

  return {
    appId: session?.intercomAppId,
    userId: user?.id?.toString(),
    userHash: user?.intercomUserHash,
  };
};

// Keep the old hook for backward compatibility
export const useIntercomAppId = (): string | undefined => {
  const { appId } = useIntercomProps();
  return appId;
};
